module.exports = __webpack_public_path__ + "Flag-92.54cd79b896a767bfe439c4839d1c7e8b.svg";